import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar';
import { useParams } from 'react-router-dom';
import { FaArrowRightLong } from "react-icons/fa6";
import { IoSearch } from "react-icons/io5";
import { IoIosArrowDropdown } from "react-icons/io";
import { IoIosReturnRight } from "react-icons/io";
import axios from 'axios';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { FaMedium } from "react-icons/fa";
import Menu_Items from '../Menu_Items';
import Loader from '../Loader';


function Fieldsmapping() {
    const { id, int_id, Ex_id } = useParams();

    const [su_admin, setsu_admin] = useState(false)
    const [admin, setadmin] = useState(false)
    const [monitor, setmonitor] = useState(false)
    const [alltables, setalltables] = useState([]);
    const [conditiontablenames, setconditiontablenames] = useState([]);
    const [conditionsfields, setconditionsfields] = useState([]);
    const [conditiontablevalues, setconditiontablevalues] = useState([]);
    const [linkedtable, setlinkedtable] = useState([]);
    const [nonefield, setnonefield] = useState([]);
    const [mappingnonetable, setmappingnonetable] = useState([]);
    const [mappingnonefield, setmappingnonefield] = useState([]);
    const [mappingdetails, setmappingdetails] = useState([]);
    const [field, setfield] = useState([]);
    const [fieldtable, setfieldtable] = useState([]);
    const [search_Tables, setsearch_Tables] = useState('');
    const [search_Fields, setsearch_Fields] = useState('');
    const [loading, setloading] = useState(true)

    const menus = [
        {
            name: 'Integrations',
            id,
        },
        {
            name: 'Out Bound',
            id,
            submenu: [{ name: 'Out Bound', id, int_id, Ex_id },
            { name: 'Conditions', id, int_id, Ex_id },
            { name: 'Linked Tables', id, int_id, Ex_id },
            { name: 'Merge Tables', id, int_id, Ex_id },
            { name: 'Config', id, int_id, Ex_id },
            { name: 'Result', id, int_id, Ex_id },
            ]
        },
        (su_admin || admin ? { name: 'Users', id } : { name: null, id })
    ];
    const gettables = async () => {
        await axios.get(`/integ/tables/${int_id}`).then((res) => {
            let values = res.data;
            if (values === 'tables Not Fetched') {
                toast.error("tables Not Fetched", {
                    autoClose: 2000, // 2 seconds
                });
            }
            else {
                setalltables(values);
            }
        })
            .catch((err) => {
                console.log("err :", err);
            });
        await axios.get(`/out_bound/export_value/${Ex_id}`).then((res) => {
            let response = res.data;
            let linkedtabledetail;
            if (response['Linked_Tables']) {
                if (response['Linked_Tables'] !== '') {
                    linkedtabledetail = JSON.parse(response['Linked_Tables']);
                    setlinkedtable(linkedtabledetail);
                };
            }
            else {
                setlinkedtable(null);
            }
            if (response['Map_Values']) {
                if (response['Map_Values'] !== '') {
                    let mapping_details = JSON.parse(response['Map_Values']);
                    setmappingdetails(mapping_details);
                    if (mapping_details.length !== 0) {
                        mapping_details.map((obj) => {
                            setconditiontablenames(prevData => [...prevData, Object.keys(obj)[0]]);
                            handleconditiontable(Object.keys(obj)[0], linkedtabledetail);
                            obj[Object.keys(obj)[0]].forEach((item) => {
                                handlefield(Object.keys(obj)[0], Object.keys(item)[0]);
                            });
                        });
                    }
                };
            }
            else {
                const Headers = response.Headers ? JSON.parse(response.Headers) : [{}]
                const tables = Headers.map(obj => Object.keys(obj)).flat();
                const fetchData = async () => {
                    const data = await Promise.all(tables.map(name => handleconditiontable(name, linkedtabledetail)));
                    const result = data.includes(false)
                    if (!result) {
                        const merged = Object.assign({}, ...Headers);
                        const result1 = tables.map(name =>
                            merged[name].map(obj => obj.field).map(val => handlefield(name, val))
                        ).flat().includes(false);
                        if (!result1) {
                            setloading(false)
                        }
                    }
                };
                fetchData();

                setmappingdetails([]);
            }
        })
            .catch((err) => {
                toast.error("Error From gettables", {
                    autoClose: 2000, // 2 seconds
                });
            });
    };
    // search by Tables
    const filterbyTables = alltables.filter(name =>
        name.toLowerCase().startsWith(search_Tables.toLowerCase())
    );
    // // search by Fields With Tables
    const filteredbyFields = conditionsfields.reduce((acc, item) => {
        const k = Object.keys(item)[0]; // Get the table name (key)
        const v = Object.values(item)[0]; // Get the fields (values)

        // If the search term matches the table name, return the whole table
        if (k.toLowerCase().startsWith(search_Fields.toLowerCase())) {
            acc.push({ [k]: v });
        } else {
            // If the search term matches a field, return only that field in the table
            const matchingFields = v.filter(val => val.toLowerCase().startsWith(search_Fields.toLowerCase()));
            if (matchingFields.length > 0) {
                acc.push({ [k]: matchingFields });
            }
        }
        return acc;
    }, []);
    // search by Mapping Fields
    // const handleSearch = () => {
    //     let searchResults = {};

    //     // Step 1: Build the initial search results
    //     field.forEach((item) => {
    //         const tname = Object.keys(item)[0]; // tname is a single string
    //         const fieldValues = Object.values(item)[0]; // fieldValues should be an array
    //         // console.log(fieldValues);
    //         if (Array.isArray(fieldValues)) {
    //             fieldValues.forEach((val) => {
    //                 const opvalues = handlemappingfields(tname, val); // Get all opvalues for this tname and val
    //                 // console.log(opvalues);
    //                 // if (Array.isArray(opvalues) && opvalues.length > 0) {
    //                 //     if (!searchResults[tname]) {
    //                 //         searchResults[tname] = {};
    //                 //     }
    //                 //     searchResults[tname][val] = opvalues;
    //                 // }
    //             });
    //         }
    //     });

    //     // Step 2: Filter the results based on the search query
    //     const filteredResults = {};

    //     Object.keys(searchResults).forEach((tname) => {
    //         const valEntries = searchResults[tname];

    //         Object.keys(valEntries).forEach((val) => {
    //             const opvalues = valEntries[val];

    //             // Check for matches
    //             const matchesTname = tname.toLowerCase().startsWith(search_Mapping.toLowerCase());
    //             const matchesVal = val.toLowerCase().startsWith(search_Mapping.toLowerCase());
    //             const matchesOpvalues = opvalues.filter(opvalue =>
    //                 opvalue.toLowerCase().startsWith(search_Mapping.toLowerCase())
    //             );

    //             // If there is any match, add it to filtered results
    //             if (matchesTname || matchesVal || matchesOpvalues.length > 0) {
    //                 if (!filteredResults[tname]) {
    //                     filteredResults[tname] = {};
    //                 }
    //                 // Add val and its opvalues if it matches
    //                 filteredResults[tname][val] = matchesOpvalues.length > 0 ? matchesOpvalues : opvalues;
    //             }
    //         });
    //     });

    //     // console.log("Filtered Results:", filteredResults); // Debugging line
    //     // Return the filtered results in the desired format
    //     return [filteredResults];
    // };

    const handleconditiontable = async (name, linkedtabledetail) => {
        try {
            if (conditiontablenames.includes(name)) {
                setconditionsfields(prevData => prevData.filter(item => !item.hasOwnProperty(name)));
                setconditiontablevalues(prevData => prevData.filter(item => !item.hasOwnProperty(name)));
                setconditiontablenames(conditiontablenames.filter(item => item !== name));
            }
            else {
                setconditiontablenames(prevState => [...prevState, name]);
                await axios.get(`/integ/field/${name}/${int_id}`).then((res) => {
                    let values = res.data;
                    setconditionsfields(prevState => [...prevState, { [name]: values }]);
                })
                    .catch((err) => {
                        console.log("Error from conditiontables.js ");
                    });
                await axios.get(`/integ/field/values/${name}/${int_id}`).then(async (res) => {
                    let values = res.data;
                    if (linkedtabledetail) {
                        if (linkedtabledetail.length !== 0) {
                            await handlelinkedtables(name, values, linkedtabledetail);
                        }
                        else {
                            setconditiontablevalues(prevState => [...prevState, { [name]: values }]);
                        }
                    } else {
                        setconditiontablevalues(prevState => [...prevState, { [name]: values }]);
                    }
                })
                    .catch((err) => {
                        console.log("Error From Tables Page");
                    });

            };
        } catch (error) {
            console.log('Error');
        } finally {
            return true
        }
    };
    const handlelinkedtables = async (name, value, linkedTableDetail) => {
        let old_values = value; // Start with the initial value array
        for (const obj of linkedTableDetail) {
            if (obj.mt === name) {
                try {
                    const res = await axios.post(`/integ/checklinked/${int_id}`, obj);
                    const values = res.data;
                    old_values = old_values.map(item => {
                        let new_values = values.find(val => val[obj.ltf] === item[obj.mtf]);


                        return { ...item, [obj.mtf]: new_values ? new_values[obj.mtf] : item[obj.mtf] };
                    });
                } catch (err) {
                    console.log('Error from test:', err);
                }
            }
        };
        // Update the state with the final array
        setconditiontablevalues(prevState => [...prevState, { [name]: old_values }]);
    };
    const none = (id) => {
        setnonefield(prevState =>
            prevState.includes(id) ? prevState.filter(divId => divId !== id) : [id]
        );
    };
    const maptnone = (id) => {
        setmappingnonetable(prevState => {
            if (prevState.includes(id)) {
                setmappingnonefield([]); // Clear the mappingnonefield if the id is found
                return prevState.filter(divId => divId !== id); // Remove the id from the array
            } else {
                return [id]; // Set the state to only contain the current id
            }
        });
    };
    const mapfnone = (id) => {
        setmappingnonefield(prevState =>
            prevState.includes(id) ? prevState.filter(divId => divId !== id) : [id]
        );
    };
    const handlefield = (key, value) => {
        setfield((prevData) => {
            let updatedData = [...prevData];
            let keyExists = false;

            // Iterate through the array to find the key
            updatedData = updatedData.map((item) => {
                if (item[key]) {
                    keyExists = true; // The key exists

                    if (item[key].includes(value)) {
                        // If the value exists, remove it
                        const updatedValues = item[key].filter((v) => v !== value);
                        setfieldtable(prevData => prevData.filter((val) => val !== `${key}${value}`));
                        return updatedValues.length > 0 ? { [key]: updatedValues } : null; // If array is empty, return null
                    } else {
                        // If the value doesn't exist, add it
                        setfieldtable(prevData => [...prevData, `${key}${value}`]);
                        return { [key]: [...item[key], value] };

                    }
                }
                return item; // Return unchanged objects
            }).filter(Boolean); // Remove null entries (i.e., those where all values were removed)

            // If the key doesn't exist, add it with the new value
            if (!keyExists) {
                updatedData.push({ [key]: [value] });
                setfieldtable(prevData => [...prevData, `${key}${value}`]); // Update fieldtable
            }

            return updatedData;
        });
        return true
    };
    const fieldmapping = (tname, field, op, t, remove = false) => {
        setmappingdetails((prevData) => {
            // Find the table by `tname`
            const tableIndex = prevData.findIndex((tobj) => tobj.hasOwnProperty(tname));

            if (tableIndex === -1) {
                // If the table does not exist and we're removing, do nothing
                if (remove) return prevData;

                // If the table does not exist, create a new table entry
                return [
                    ...prevData,
                    {
                        [tname]: [
                            { [field]: [{ op_value: op, t_value: t }] }
                        ]
                    }
                ];
            }

            // If the table exists, update the existing table
            const updatedTable = prevData.map((tobj, index) => {
                if (index === tableIndex) {
                    // Find the field in the table
                    const fieldIndex = tobj[tname].findIndex((fobj) => fobj.hasOwnProperty(field));

                    if (fieldIndex === -1) {
                        // If the field does not exist, and we're removing, do nothing
                        if (remove) return tobj;

                        // If the field does not exist, create a new field entry
                        return {
                            ...tobj,
                            [tname]: [
                                ...tobj[tname],
                                { [field]: [{ op_value: op, t_value: t }] }
                            ]
                        };
                    }

                    // If the field exists, check for `op_value`
                    const updatedFields = tobj[tname].map((fobj, idx) => {
                        if (idx === fieldIndex) {
                            if (remove) {
                                // Remove the entry with matching `op_value`
                                const filteredOperations = fobj[field].filter((opObj) => opObj.op_value !== op);

                                // If the filtered operations array is empty, remove the field entirely
                                if (filteredOperations.length === 0) {
                                    return null; // Mark this field for removal
                                }

                                return { ...fobj, [field]: filteredOperations };
                            }

                            const operationIndex = fobj[field].findIndex((opObj) => opObj.op_value === op);

                            if (operationIndex === -1) {
                                // If the `op_value` does not exist, add a new entry
                                return {
                                    ...fobj,
                                    [field]: [...fobj[field], { op_value: op, t_value: t }]
                                };
                            }

                            // If the `op_value` exists, update the `t_value`
                            const updatedOperations = fobj[field].map((opObj, opIdx) => {
                                if (opIdx === operationIndex) {
                                    return { ...opObj, t_value: t }; // Update `t_value` for the existing `op_value`
                                }
                                return opObj;
                            });

                            return { ...fobj, [field]: updatedOperations };
                        }
                        return fobj;
                    }).filter(fobj => fobj !== null); // Remove any opvalue marked for deletion

                    // If the updated fields are empty, return null to mark the table for removal
                    if (updatedFields.length === 0) {
                        return null;
                    }

                    return {
                        ...tobj,
                        [tname]: updatedFields
                    };
                }
                return tobj;
            }).filter(tobj => tobj !== null); // Remove any tables marked for deletion

            return updatedTable;
        });
    };
    const handlemapping = (tname, val, opvalue, e) => {
        if (e.target.value === '') {
            // Input was cleared, do something specific for the 'X' mark click
            fieldmapping(tname, val, opvalue, '', true);
        } else {
            // Handle normal input changes
            fieldmapping(tname, val, opvalue, e.target.value);
        }
    };
    const handlemappingsubmit = async () => {
        let value = JSON.stringify(mappingdetails);
        let mappingvalue = {
            Map_Values: value
        };
        await axios.patch(`/out_bound/mapping/${Ex_id}`, mappingvalue).then((res) => {
            toast.success("Fields Mapping Details Updated", {
                autoClose: 2000, // 2 seconds
            });
        })
            .catch((err) => {
                toast.error("Mapping Details api error", {
                    autoClose: 2000, // 2 seconds
                });
            });
    };
    const handle_op_value = (tname, fname, op_name) => {
        for (const obj of mappingdetails) {
            if (obj[tname]) {
                for (const val of obj[tname]) {
                    if (val[fname]) {
                        const match = val[fname].find((op_val) => op_val['op_value'] === op_name);
                        if (match) {
                            return match['t_value'];
                        }
                    }
                }
            }
        }
        return undefined; // Return undefined if no match is found

    }
    const mappingfields = (tname) => {
        return conditiontablevalues.length > 0 && conditiontablevalues.map((cobj) => {
            if (cobj[tname]) {
                return cobj[tname].length > 0 && cobj[tname].map((obj) => {
                    return obj;
                })
            }

        })
    };
    const get_level = () => {
        const level = Cookies.get("level");
        if (level === "Super Admin") {
            setsu_admin(true);
        }
        else if (level === 'Admin') {
            setadmin(true)
        }
        else {
            setmonitor(true)
        }

    };
    useEffect(() => {
        gettables();
        get_level();
    }, [])
    return (
        <div className='container df fdc jb ac'>
            <Navbar />
            <div className='main_box df'>
                <Menu_Items menu={menus} />
                <div className='content df fdc ac'>
                    <div className='page_header df jb ac'>
                        <div className='w90 df ac'>
                            <FaMedium className='page_icon db' />
                            <p>Fields Mapping</p>
                        </div>
                    </div>
                    <div className='box df jc ac'>
                        <div className='mp_box3'>
                            {
                                loading ? <Loader /> : <>
                                    <div className='box1_con df fdc ac'>
                                        {
                                            field.length > 0 && field.map((obj, index) => {
                                                const tname = Object.keys(obj)[0];
                                                const fieldname = obj[tname];
                                                const Tablename = tname.charAt(0).toUpperCase() + tname.slice(1);
                                                return (
                                                    <React.Fragment key={`table-${index}`}>
                                                        <p className='mapping_fields_tablename df ac jb g '>
                                                            {Tablename}
                                                            <div className='df jc ac'>
                                                                <IoIosArrowDropdown className='db' onClick={() => maptnone(`${tname}`)} />
                                                            </div>
                                                        </p>
                                                        {
                                                            fieldname.length > 0 && fieldname.map((fname, ind) => {
                                                                let field = fname.charAt(0).toUpperCase() + fname.slice(1);
                                                                return (
                                                                    <React.Fragment key={`field-${ind}-${index}`}>
                                                                        <div className='mapping_fields_header df ac' id={mappingnonetable.includes(`${tname}`) ? 'show' : 'none'}>
                                                                            <div className='mapping_fields_header_icon'>
                                                                                <IoIosReturnRight className='icon2 b' />
                                                                            </div>
                                                                            <p>{field}</p>
                                                                            <div>
                                                                                <IoIosArrowDropdown
                                                                                    className='icon1 db'
                                                                                    onClick={() => mapfnone(`${tname}${field}`)}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            className='mapping_fields_field w80'
                                                                            id={mappingnonefield.includes(`${tname}${field}`) ? 'block' : 'none'}>
                                                                            {
                                                                                mappingfields(tname).length > 0 && mappingfields(tname).map((obj, mfindex1) => {
                                                                                    if (obj) {
                                                                                        return obj.map((val, mfindex2) => {
                                                                                            if (val) {
                                                                                                let opvalue =
                                                                                                    val[fname] && typeof val[fname] === 'string'
                                                                                                        ? val[fname].charAt(0).toUpperCase() + val[fname].slice(1)
                                                                                                        : val[fname];
                                                                                                if (val[fname] !== '') {
                                                                                                    return (
                                                                                                        <div className='mapping_field_content w100 df js ac' key={`value-${index}-${ind}-${mfindex1}-${mfindex2}`}>
                                                                                                            <p className='b1 w50 df ac' id={`p${mfindex1}`}>
                                                                                                                {opvalue}
                                                                                                            </p>
                                                                                                            <div className='map_op_val df jc ac' id={`d1${mfindex1}`}>
                                                                                                                <FaArrowRightLong className='db' id={`i${mfindex2}`} />
                                                                                                            </div>
                                                                                                            <input type='search'
                                                                                                                id={val[fname]}
                                                                                                                value={handle_op_value(tname, fname, val[fname]) ? handle_op_value(tname, fname, val[fname]) : opvalue}
                                                                                                                onChange={(e) => handlemapping(tname, fname, val[fname], e)} disabled={monitor}
                                                                                                                className='h3'
                                                                                                            //  tname fname val[fname] handle_op_value
                                                                                                            />
                                                                                                        </div>
                                                                                                    )
                                                                                                }

                                                                                            }

                                                                                        })
                                                                                    }


                                                                                })

                                                                            }

                                                                        </div>
                                                                    </React.Fragment>
                                                                )
                                                            })
                                                        }
                                                    </React.Fragment>


                                                )

                                            })
                                        }
                                    </div>
                                    {
                                        mappingdetails.length > 0 && <div className='mapping_submit df jc ac'>
                                            {!monitor && <button className='btn green' onClick={handlemappingsubmit}>Submit</button>}
                                        </div>
                                    }
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Fieldsmapping;